<template>
  <div class="wrap">
    <div class="user-info">
      <div class="flex-row-between">
        <div class="flex-row-start">
          <img src="../../assets/images/icon4.png" />
          <div class="base-info flex-col-center">
            <div class="flex-row-start">
              <div>
                <span>{{ userInfo.name ? userInfo.name : '未登录' }}</span>
                <img v-if="userInfo.haveVip" @click="toVipCardRecord" src="../../assets/images/vip (1).png" />
                <img v-else @click="toVipCard" src="../../assets/images/vip.png" />
              </div>
            </div>
            <div @click="toLogin">{{ userInfo.tel ? userInfo.tel : '' }}</div>
          </div>
        </div>
        <div></div>
      </div>
    </div>
    <div class="function-container">
      <!-- 功能区 -->
      <div class="function-item">
        <div class="block">
          <div class="font-bigger">常用功能</div>
          <div class="border">
            <van-cell title="个人信息" border icon="comment-o" is-link to="user-info" />
          </div>
          <div class="border">
            <van-cell title="我的档案" border icon="friends-o" is-link to="student" />
          </div>
          <div>
            <van-cell title="我的报告" border icon="todo-list-o" is-link to="testing-record" />
          </div>
          <div>
            <van-cell title="推广记录" icon="cluster-o" is-link to="share-record" />
          </div>
          <div>
            <van-cell title="会员卡" icon="vip-card-o" is-link to="vip-card" />
          </div>
        </div>
        <div class="block" style="margin-top: 20px;">
          <div class="font-bigger">系统设置</div>
          <div class="border">
            <van-cell @click="toRichText('confidentiality_agreement')" title="隐私协议" border icon="eye-o" is-link />
          </div>
          <div>
            <van-cell @click="toRichText('confidentiality_agreement')" title="用户协议" border icon="good-job-o" is-link />
          </div>
          <div>
            <van-cell @click="logout" title="退出登录" border icon="revoke" is-link />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import wx from 'weixin-js-sdk';	// 使用js-sdk
import { fetchUserInfo } from '../../api/user'
import { logout, jsSDKSign } from '../../api/login'
import { Dialog, Toast } from 'vant'
export default {
  data() {
    return {
      userInfo: {},
      wxShareConfig: {
        title: '邀您注册',
        desc: 'AI专属营养师',
        link: '',
        imgUrl: 'http://kangpingoss.oss-cn-beijing.aliyuncs.com/8d22029b9cd947d08237eb53f461a4cc.jpg',
        jsApiList: [ 'updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareWeibo', 'onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ' ], // 分享给朋友分享到QQ  分享到朋友圈 分享到腾讯微博
      }
    }
  },
  components: {
  },
  created() {
    this.init()
  },
  watch: {
    $route() {
      this.init()
    }
  },
  methods: {
    async init() {
      if (localStorage.getItem('reload')) {
        localStorage.removeItem('reload')
        window.location.reload()
      }
      this.wxShareConfig.link = `https://kpapi.kpjkgl.com/#/login?companyId=${localStorage.getItem('CompanyId')}&inviterId=${localStorage.getItem('UserId')}`
      await fetchUserInfo().then(res => {
        this.userInfo = res
      })
      await jsSDKSign(window.location.href.split('#/')[0]).then(res => {
        this.injectAndShare(res)
      })
    },
    toRichText(code) {
      this.$router.push({
        path: '/rich-text',
        query: {
          code: code
        }
      })
    },
    toStudent() {
      this.$router.push({
        path: '/student'
      })
    },
    toVipCard() {
      fetchUserInfo().then(() => {
        this.$router.push({
          path: '/vip-card',
          query: {}
        })
      })
    },
    toVipCardRecord() {
      fetchUserInfo().then(() => {
        this.$router.push({
          path: '/vip-card-record',
          query: {}
        })
      })
    },
    toLogin() {
      if (this.userInfo.userId) return false
      this.$router.push({
        path: '/login'
      })
    },
    logout() {
      // 退出登录
      Dialog.confirm({
        title: '提示',
        message: '是否要退出吗？'
      }).then(() => {
        logout().then(() => {
          Toast('退出成功')
          this.userInfo = {}
        })
      })
        .catch(() => {
        })
    },
    injectAndShare(signMsg) {

      const that = this
      signMsg.timestamp = signMsg.timestamp.toString()
      // 访问页面和获取页面必须保持一致
      // console.log('url 比对结果',  location.href.split('#')[0] === signMsg.url )
      wx.config({
        debug: false,  // 开发期间启用
        appId: signMsg.appId,
        timestamp: signMsg.timestamp,   // 注意！时间戳这里应该是10位字符串
        nonceStr: signMsg.nonceStr,     // 注意驼峰命名
        signature: signMsg.signature,
        jsApiList: [
          'updateAppMessageShareData',
          'updateTimelineShareData',
          'onMenuShareWeibo',
          'onMenuShareTimeline',
          'onMenuShareAppMessage',
          'onMenuShareQQ'
        ],
      })

      wx.ready(() => {
        const { title, desc, link, imgUrl } = that.wxShareConfig
        console.log('wx.ready', '注入成功')

        // wx.checkJsApi({
        //   jsApiList:  ['updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareWeibo', 'onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ' ], // 需要检测的JS接口列表，所有JS接口列表见附录2,
        //   success: function(res) {
        //   // 可用的api值true，不可用为false
        //   // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
        //     console.log('#####checkJsApi#####', res)
        //   }
        // });

        wx.updateAppMessageShareData({
          title, desc, link, imgUrl,
          success: function () {
            console.log('分享成功！')
          },
          cancel: function () {
            console.log('分享取消！')
          },
          fail: function () {
            console.log('分享失败！')
          }
        })

        wx.updateTimelineShareData({
          title, desc, link, imgUrl,
          success: function () {
            console.log('分享成功！')
          },
          cancel: function () {
            console.log('分享取消！')
          },
          fail: function () {
            console.log('分享失败！')
          }
        })


        wx.onMenuShareWeibo({
          title, desc, link, imgUrl,
          success: function () {
            console.log('分享成功！')
          },
          cancel: function () {
            console.log('分享取消！')
          },
          fail: function () {
            console.log('分享失败！')
          }
        })

        // 即将废弃（为兼容安卓最好加上）
        wx.onMenuShareTimeline({
          title, desc, link, imgUrl,
          success: function () {
            console.log('分享成功！')
          },
          cancel: function () {
            console.log('分享取消！')
          },
          fail: function () {
            console.log('分享失败！')
          }
        })

        // 即将废弃（为兼容安卓最好加上）
        wx.onMenuShareAppMessage({
          title, desc, link, imgUrl,
          success: function () {
            console.log('分享成功！')
          },
          cancel: function () {
            console.log('分享取消！')
          },
          fail: function () {
            console.log('分享失败！')
          }
        })

        // 即将废弃（为兼容安卓最好加上）
        wx.onMenuShareQQ({
          title, desc, link, imgUrl,
          success: function () {
            console.log('分享成功！')
          },
          cancel: function () {
            console.log('分享取消！')
          },
          fail: function () {
            console.log('分享失败！')
          }
        })

      })

      wx.error(function (res) {
        console.log('wx error:', res)
      })

    }
  }
};
</script>
<style lang="less" scoped>
@import url('../../assets/css/style.css');

.wrap {
  min-height: 100%;
  .user-info {
    img {
      border-radius: 120px;
      border: #f3f3f3 solid 8px;
      height: 120px;
      width: 120px;
    }

    div {
      color: #fff;
      font-size: 0.38rem;
    }

    .base-info {
      height: 120px;
      padding-left: 40px;
      align-items: flex-start;

      div:last-child {
        margin-top: 18px;
      }

      img {
        border: none;
        padding: 0;
        width: 81px;
        height: 69px;
        margin-left: 10px;
      }
    }

    padding: 80px 40px 120px 40px;
    background: linear-gradient(240deg, #ffc928, #ff9e19);
    border-radius: 0 0 80px 80px;
  }

  .function-container {
    padding: 40px 40px 120px 40px;
  }

  .function-item {

    .block {
      padding: 40px 40px 24px 40px;
      border-radius: 20px;
      background: #ffffff;

      .border {
        border-bottom: #f3f3f3 solid 2px;
      }

      .van-cell {
        padding: 24px 0;
      }
    }
  }
}
</style>